/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetANumberHistoryResponse } from '../model/getANumberHistoryResponse';
import { GetActiveCallsResponse } from '../model/getActiveCallsResponse';
import { GetAgentSMSLogResponse } from '../model/getAgentSMSLogResponse';
import { GetCallLogResponse } from '../model/getCallLogResponse';
import { GetQueuedCallsResponse } from '../model/getQueuedCallsResponse';
import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { AttendantServiceInterface }                            from './attendant.serviceInterface';


@Injectable()
export class AttendantService implements AttendantServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param callee 
     * @param displayNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clickToCall1(callee: string, displayNumber: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public clickToCall1(callee: string, displayNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public clickToCall1(callee: string, displayNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public clickToCall1(callee: string, displayNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callee === null || callee === undefined) {
            throw new Error('Required parameter callee was null or undefined when calling clickToCall1.');
        }

        if (displayNumber === null || displayNumber === undefined) {
            throw new Error('Required parameter displayNumber was null or undefined when calling clickToCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/call/${encodeURIComponent(String(callee))}/${encodeURIComponent(String(displayNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public completeTransferCall1(sessionId: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public completeTransferCall1(sessionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public completeTransferCall1(sessionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public completeTransferCall1(sessionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling completeTransferCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/completeTransfer/${encodeURIComponent(String(sessionId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dequeueCall1(sessionId: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public dequeueCall1(sessionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public dequeueCall1(sessionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public dequeueCall1(sessionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling dequeueCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/dequeue/${encodeURIComponent(String(sessionId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dequeueCallToColleague1(sessionId: number, login: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public dequeueCallToColleague1(sessionId: number, login: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public dequeueCallToColleague1(sessionId: number, login: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public dequeueCallToColleague1(sessionId: number, login: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling dequeueCallToColleague1.');
        }

        if (login === null || login === undefined) {
            throw new Error('Required parameter login was null or undefined when calling dequeueCallToColleague1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/dequeue/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(login))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param intendedLeg 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disconnectCall1(sessionId: number, intendedLeg: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public disconnectCall1(sessionId: number, intendedLeg: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public disconnectCall1(sessionId: number, intendedLeg: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public disconnectCall1(sessionId: number, intendedLeg: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling disconnectCall1.');
        }

        if (intendedLeg === null || intendedLeg === undefined) {
            throw new Error('Required parameter intendedLeg was null or undefined when calling disconnectCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/disconnect/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(intendedLeg))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aNumber 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getANumberHistory1(aNumber: string, organization?: string, login?: string, from?: string, to?: string, observe?: 'body', reportProgress?: boolean): Observable<GetANumberHistoryResponse>;
    public getANumberHistory1(aNumber: string, organization?: string, login?: string, from?: string, to?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetANumberHistoryResponse>>;
    public getANumberHistory1(aNumber: string, organization?: string, login?: string, from?: string, to?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetANumberHistoryResponse>>;
    public getANumberHistory1(aNumber: string, organization?: string, login?: string, from?: string, to?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (aNumber === null || aNumber === undefined) {
            throw new Error('Required parameter aNumber was null or undefined when calling getANumberHistory1.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetANumberHistoryResponse>(`${this.basePath}/attendant/anumberhistory/${encodeURIComponent(String(aNumber))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveCalls1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetActiveCallsResponse>;
    public getActiveCalls1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetActiveCallsResponse>>;
    public getActiveCalls1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetActiveCallsResponse>>;
    public getActiveCalls1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetActiveCallsResponse>(`${this.basePath}/attendant/activecalls`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAgentCallLog1(organization?: string, login?: string, from?: string, to?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCallLogResponse>;
    public getAgentCallLog1(organization?: string, login?: string, from?: string, to?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCallLogResponse>>;
    public getAgentCallLog1(organization?: string, login?: string, from?: string, to?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCallLogResponse>>;
    public getAgentCallLog1(organization?: string, login?: string, from?: string, to?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCallLogResponse>(`${this.basePath}/attendant/agentcalllog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAgentSMSLog1(organization?: string, login?: string, from?: string, to?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAgentSMSLogResponse>;
    public getAgentSMSLog1(organization?: string, login?: string, from?: string, to?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAgentSMSLogResponse>>;
    public getAgentSMSLog1(organization?: string, login?: string, from?: string, to?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAgentSMSLogResponse>>;
    public getAgentSMSLog1(organization?: string, login?: string, from?: string, to?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAgentSMSLogResponse>(`${this.basePath}/attendant/agentsmslog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallLog1(serviceNumber: string, organization?: string, login?: string, from?: string, to?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCallLogResponse>;
    public getCallLog1(serviceNumber: string, organization?: string, login?: string, from?: string, to?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCallLogResponse>>;
    public getCallLog1(serviceNumber: string, organization?: string, login?: string, from?: string, to?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCallLogResponse>>;
    public getCallLog1(serviceNumber: string, organization?: string, login?: string, from?: string, to?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling getCallLog1.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCallLogResponse>(`${this.basePath}/attendant/calllog/${encodeURIComponent(String(serviceNumber))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueuedCalls1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetQueuedCallsResponse>;
    public getQueuedCalls1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQueuedCallsResponse>>;
    public getQueuedCalls1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQueuedCallsResponse>>;
    public getQueuedCalls1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetQueuedCallsResponse>(`${this.basePath}/attendant/queuedcalls`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public parkCall1(sessionId: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public parkCall1(sessionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public parkCall1(sessionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public parkCall1(sessionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling parkCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/park/${encodeURIComponent(String(sessionId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param intendedLeg 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public retrieveCall1(sessionId: number, intendedLeg: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public retrieveCall1(sessionId: number, intendedLeg: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public retrieveCall1(sessionId: number, intendedLeg: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public retrieveCall1(sessionId: number, intendedLeg: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling retrieveCall1.');
        }

        if (intendedLeg === null || intendedLeg === undefined) {
            throw new Error('Required parameter intendedLeg was null or undefined when calling retrieveCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/retrieve/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(intendedLeg))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCallLogCalledBack1(id: number, organization?: string, login?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setCallLogCalledBack1(id: number, organization?: string, login?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setCallLogCalledBack1(id: number, organization?: string, login?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setCallLogCalledBack1(id: number, organization?: string, login?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setCallLogCalledBack1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/attendant/calllog/${encodeURIComponent(String(id))}/calledback`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCallLogComment1(id: number, organization?: string, login?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setCallLogComment1(id: number, organization?: string, login?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setCallLogComment1(id: number, organization?: string, login?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setCallLogComment1(id: number, organization?: string, login?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setCallLogComment1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/attendant/calllog/${encodeURIComponent(String(id))}/comment`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCallLogHandled1(id: number, organization?: string, login?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setCallLogHandled1(id: number, organization?: string, login?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setCallLogHandled1(id: number, organization?: string, login?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setCallLogHandled1(id: number, organization?: string, login?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setCallLogHandled1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/attendant/calllog/${encodeURIComponent(String(id))}/handled`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param intendedLeg 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toggleCall1(sessionId: number, intendedLeg: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public toggleCall1(sessionId: number, intendedLeg: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public toggleCall1(sessionId: number, intendedLeg: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public toggleCall1(sessionId: number, intendedLeg: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling toggleCall1.');
        }

        if (intendedLeg === null || intendedLeg === undefined) {
            throw new Error('Required parameter intendedLeg was null or undefined when calling toggleCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/toggle/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(intendedLeg))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param transferee 
     * @param consultationMode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transferCall1(sessionId: number, transferee: string, consultationMode: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public transferCall1(sessionId: number, transferee: string, consultationMode: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public transferCall1(sessionId: number, transferee: string, consultationMode: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public transferCall1(sessionId: number, transferee: string, consultationMode: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling transferCall1.');
        }

        if (transferee === null || transferee === undefined) {
            throw new Error('Required parameter transferee was null or undefined when calling transferCall1.');
        }

        if (consultationMode === null || consultationMode === undefined) {
            throw new Error('Required parameter consultationMode was null or undefined when calling transferCall1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/transfer/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(transferee))}/${encodeURIComponent(String(consultationMode))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param cid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transferCallToQueue1(sessionId: number, cid: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public transferCallToQueue1(sessionId: number, cid: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public transferCallToQueue1(sessionId: number, cid: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public transferCallToQueue1(sessionId: number, cid: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling transferCallToQueue1.');
        }

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling transferCallToQueue1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/attendant/transfer/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(cid))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
